import { Action } from 'redux'
import { notification } from 'antd'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IShareItpPayload } from '@app-store/slices/companies/shareItp'

interface TaskAction extends Action {
    payload: IShareItpPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.companies.shareItp

function* shareItpSagaTask({ payload }) {
    try {
        const response = yield axios.post(`/companies/share-itp`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess()
            notification.success({
                message: 'ITP shared successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* shareItpSaga(): any {
    yield takeLatest<TaskAction>(onRequest, shareItpSagaTask)
}

export default shareItpSaga
